import React from "react";
import Chat from "./Chat";
import "./App.css";

function App() {
  return (
      <div className="App">
        <Chat />
      </div>
  );
}

export default App;